module.exports = __webpack_public_path__ + "img/3FAC106C0CA260773D90458A289E3C7C.f9c01f0c.jpg";